import { PlusIcon } from '@heroicons/react/20/solid';
import { useState, useEffect } from 'react';
import { updateObjective } from '../../store/map3PendingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { getShortIdFromUuid } from '@mm-shared/utils/getShortIdFromUuid';
import { createResult1 } from '@mm-shared/types/Result1.utils';
import { useCurrentMap } from '../../hooks/useCurrentMap';
// import { selectUserRoleForMap } from '../../store/selectors';
import { useRoleWithOverride } from '../../hooks/useRoleWithOverride';
import { getPermissionsForRole } from '../../utils/getPermissionsForRole';

interface AddResultButtonProps {
  latestIntervalEnding: string;
  objectiveUuid: string;
}

export function AddResultButton1({ latestIntervalEnding, objectiveUuid }: AddResultButtonProps) {
  const [isAddingNewResult, setIsAddingNewResult] = useState(false);
  const [inputText, setInputText] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const objective = useSelector((state: RootState) =>
    state.map3Data.objectives.find((obj) => obj.uuid === objectiveUuid),
  );

  // Check user's role for add permissions
  const currentMap = useCurrentMap();
  // const userRole = useSelector((state: RootState) =>
  //   currentMap ? selectUserRoleForMap(state, currentMap.uuid) : null,
  // );
  const userRole = useRoleWithOverride(currentMap?.uuid || '');
  const { canEdit } = getPermissionsForRole(userRole);

  // Don't render the button if user can't edit
  if (!canEdit) {
    return null;
  }

  const handleSubmit = () => {
    if (inputText.trim()) {
      handleAddNewResult(inputText, latestIntervalEnding);
    }
    setIsAddingNewResult(false);
    setInputText('');
  };

  const handleAddNewResult = (text: string, intervalEnding: string) => {
    if (!objective || !text.trim()) return;
    if (!canEdit) {
      console.warn('Add result denied: user does not have edit permissions');
      return;
    }

    const newResult = createResult1({
      text: text.trim(),
      deadline: intervalEnding,
    });

    // Get existing results array
    const existingResults = objective?.results || [];

    // Create updated results array with the new result
    const updatedResults = [...existingResults, newResult];

    // Dispatch the update with the entire updated results array
    dispatch(
      updateObjective({
        uuid: objective.uuid,
        updates: {
          results: updatedResults,
        },
      }),
    );
  };

  return (
    <div className="flex items-center pt-4">
      {isAddingNewResult ? (
        <div className="flex items-start space-x-2 mt-2 w-full">
          <input
            type="checkbox"
            checked={false}
            disabled
            className="mt-1 h-4 w-4 rounded border-gray-300"
          />
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onBlur={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
              } else if (e.key === 'Escape') {
                setIsAddingNewResult(false);
                setInputText('');
              }
            }}
            className="flex-1 px-2 py-1 rounded border border-gray-300 dark:bg-zinc-700 dark:text-white"
            placeholder="Enter new result"
            autoFocus
          />
        </div>
      ) : (
        <button
          onClick={() => setIsAddingNewResult(true)}
          className="w-full flex items-center justify-center text-gray-400 hover:text-blue-600 border border-transparent hover:border-blue-600 hover:border-dashed rounded-md py-2"
        >
          <PlusIcon className="h-5 w-5" />
          <span className="ml-2 italic">Add result</span>
        </button>
      )}
    </div>
  );
}
